import PropTypes from "prop-types";
import React, { useEffect } from "react";
import NipWrapper from "../../components/Nip/NipWrapper";
import { useHistory } from "react-router-dom";
import NipGroup from "../../assets/assets/nip-group.svg";
import Pdf from "../../assets/assets/nip-red.svg";
import Interaction from "../../components/Nip-Outward-Interaction/Interaction";
import { getUserStatus } from "../../redux/Actions/GetDocsActions";
import { connect } from "react-redux";

const Home = (props) => {
  const history = useHistory();

  const { getStatus, dashboardData, getStatusSuccess } = props;

  useEffect(
    () => {
      getStatus();
    },
    // eslint-disable-next-line
    [getStatus]
  );

  const application_info =
    dashboardData && dashboardData[2] && dashboardData[2].application_info;
  const nipDoc =
    application_info &&
    application_info.filter((item) => item.name === "NIBSS INSTANT PAYMENT");
  const doc = nipDoc && nipDoc[0];

  const check = getStatusSuccess && doc && doc.length !== 0;

  const goToDocs = () => {
    history.push({
      pathname: `/doc/NIP`,
      state: {
        id: doc && doc.id,
        link: doc && doc.url,
        name: doc && doc.name,
      },
    });
  };

  return (
    <NipWrapper>
      <div className="nip-home">
        <div className="nip-home-header">
          <div className="nip-home-header-title">NIP Documentation</div>
          <div className="nip-home-header-subtitle">
            Welcome to the Nibss NIP Documentation where you’ll learn how to
            build amazing payment experiences with the Nibss NIP API.
          </div>
        </div>

        <div className="nip-home-started">
          <div className="nip-home-started-title">Getting started</div>

          <div className="nip-home-started-red-box">
            <div className="nip-home-started-red-box-inner">
              <img src={NipGroup} alt="pdf-icon" />
            </div>

            <div className="nip-home-started-red-box-bottom">
              <div className="nip-home-started-red-box-bottom-left">
                <div className="nip-home-started-red-box-bottom-left-pdf">
                  <img src={Pdf} alt="pdf-icon" />
                </div>
                <div className="nip-home-started-red-box-bottom-left-text">
                  <h1>NIP Document</h1>
                  <p>NIP API Specification</p>
                </div>
              </div>
              {check && (
                <div className="nip-home-started-red-box-bottom-right">
                  <button data-testid="goToDocs" onClick={() => goToDocs()}>
                    view
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>

        <Interaction />
      </div>
    </NipWrapper>
  );
};

Home.propTypes = {
  dashboardData: PropTypes.any,
  getStatus: PropTypes.func,
  getStatusSuccess: PropTypes.any,
  location: PropTypes.shape({
    state: PropTypes.shape({
      id: PropTypes.any,
      link: PropTypes.any,
      name: PropTypes.any,
    }),
  }),
};

const mapDispatchToProps = (dispatch) => ({
  getStatus: () => dispatch(getUserStatus()),
});

const mapStateToProps = (state) => {
  return {
    dashboardData: state.docs.status,
    getStatusSuccess: state.docs.getStatusSuccess,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
